<template>
  <article
    class="newsletter"
    v-if="public || isDevEnvironment"
    :class="[
      (data.important && 'accent-volth') || 'accent-didi',
      { faded: !public },
    ]"
  >
    <header>
      <h1 class="title">{{ $t(data.title) }}</h1>
      <i18n tag="p" class="subtitle" path="postDateFormat">
        <template v-slot:day>{{ data.posted.day }}</template>
        <template v-slot:month>{{
          $t(`monthNames[${data.posted.month - 1}]`)
        }}</template>
        <template v-slot:year>{{ data.posted.year }}</template>
      </i18n>
    </header>
    <main>
      <a
        v-if="data.heroImageUrl"
        class="hero-image silent"
        :href="heroImageUrl"
        target="_blank"
        ><img :src="heroImageUrl"
      /></a>
      <template v-if="data.version && data.version == 2">
        <section v-for="section in data.blocks">
          <content-block
            v-for="block in section.content"
            v-bind:content="block"
            v-if="
              !block.hideForLocales ||
              !block.hideForLocales.includes($i18n.locale)
            "
          />
        </section>
      </template>
      <template v-else>
        <DeprecatedContentBlock
          v-for="block in data.blocks"
          v-if="
            !block.hideForLocales ||
            !block.hideForLocales.includes($i18n.locale)
          "
          :block="block"
        />
      </template>
    </main>
  </article>
</template>

<script>
import dynamicLocalization from "../../mixins/dynamic-localization";
import DeprecatedContentBlock from "@/components/newsletter/blocks/ContentBlock";
import ContentBlock from "@/components/content-block/index";

export default {
  mixins: [dynamicLocalization],
  components: {
    ContentBlock,
    DeprecatedContentBlock,
  },
  data() {
    return {
      isDevEnvironment: process.env.VUE_APP_STAGE.startsWith("dev/"),
    };
  },
  props: {
    data: {
      type: Object,
    },
  },
  computed: {
    heroImageUrl() {
      if (this.data.heroImageUrl && this.data.heroImageUrl.de === null) {
        return;
      }

      if (!this.data.heroImageUrl.de) {
        this.data.heroImageUrl = {
          de: this.data.heroImageUrl,
          en: this.data.heroImageUrl,
        };
      }

      if (!this.data.heroImageUrl.de) {
        return;
      }

      return this.data.heroImageUrl[this.$root.$i18n.locale].replace(
        /%BASE_URL%/g,
        ""
      );
    },
    public() {
      const now = new Date();

      const publicationDate = new Date(
        this.data.posted.year,
        this.data.posted.month - 1,
        this.data.posted.day,
        this.data.posted.hour || 12,
        this.data.posted.minute || 0
      );

      return now.getTime() >= publicationDate.getTime();
    },
  },
};
</script>

<i18n src="./i18n.json" />
<i18n src="@/locales/global.json" />

<style scoped lang="scss">
article.newsletter {
  position: relative;

  &.faded {
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }

  a.hero-image {
    padding: 0;
    float: right;
    margin-top: -60px;
    margin-bottom: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
    position: relative;
    transform: rotate(-5deg);
    margin-left: 20px;
    transition: transform 200ms ease-in-out;
    border-radius: 4px;
    overflow: hidden;

    img {
      width: 240px;
    }

    &:hover {
      transform: none;
    }

    @media screen and (max-width: 1000px) {
      transform: none;
      width: 100%;
      margin-left: 0;
      margin: 0 0 2em;

      img {
        width: 100%;
        border-radius: 10px;
      }
    }
  }
}
</style>
